import { useRef, useState } from "react";
import { useField } from "formik";
import { ArrowLongRightIcon, ChevronDownIcon } from "../../../assets/icons";
import "./EyeMeasurementInput.scss";

function EyeMeasurementInput({ name, disabled, ...props }) {
  const [field, meta, helpers] = useField(name);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);

  const { value } = field;
  const { setValue } = helpers;

  function updateValue(newValue) {
    if (!disabled) {
      if (newValue === "") {
        setValue(null);
      } else {
        setValue(newValue);
      }
      setShowDropdown(false);
    }
  }

  return (
    <div className="eye-measurement-input-wrapper">
      <div
        className={`eye-measurement-input ${meta.touched && meta.error ? "error" : ""}`}
      >
        <button
          type="button"
          className="value-field"
          onClick={() => !disabled && setShowDropdown((prev) => !prev)}
          onBlur={() => helpers.setTouched(true)}
        >
          <p>{!value || value === "" ? "-" : value}</p>
          <ChevronDownIcon />
        </button>

        <div className={`dropdown ${showDropdown && !disabled ? "show" : ""}`}>
          <div className="dropdown-item">
            <button type="button" onClick={() => updateValue("PLANO")}>
              Plano
            </button>
          </div>
          <div className="dropdown-item">
            <div className="text-input">
              <input
                type="number"
                name={name ? `${name}_helper` : "eye_measurement_helper"}
                ref={inputRef}
                placeholder="Value"
                disabled={!showDropdown || disabled}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    updateValue(inputRef.current.value);
                  }
                }}
              />
              <button
                type="button"
                onClick={() => updateValue(inputRef.current.value)}
              >
                <ArrowLongRightIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
      {meta.touched && meta.error ? (
        <div className="error-message">{meta.error}</div>
      ) : null}
    </div>
  );
}

export default EyeMeasurementInput;
